import React, { useCallback } from 'react';
import * as tokenMetadataService from '../../../services/tokenMetadataService';

const useTokenMetadata = () => {

    const findToken = useCallback(async (address: string, chainId: number) => {
        try {
            const response = await tokenMetadataService.findTokenMetadata(address, chainId);
            const roleData = response.data;
            return roleData;
        } catch (error) {
            console.error("Failed to fetch token metadata:", error);
            throw error; 
        }
    }, []);

    return {
        findToken
    };
};

export default useTokenMetadata;
